import Vue from 'vue'//主组件
import Router from 'vue-router'
import store from '@/script/store'   //状态管理器
import { message, Modal } from 'ant-design-vue'
import { constantRouterMap, getAsyncRoutes } from '@/router/initroute'



Vue.use(Router)



const createRouter = () => new Router({
  // mode: 'history',
  routes: constantRouterMap,
  linkActiveClass: ''
})
const router = createRouter()

function init() {
  let xhr = new XMLHttpRequest();
  xhr.open(
    "GET",
    // "http://localhost:5555/net/client/sort/select/"
    "https://api.oopvr.com:8080/net/client/sort/select/"
  );
  xhr.send();
  xhr.onload = (e) => {
    //获取请求数据
    const routerData = getAsyncRoutes(JSON.parse(xhr.response).data).reverse();
    //合并请求数据
    constantRouterMap.push(...routerData);
    //存储请求数据
    store.commit("setRouterData", routerData)
    //存储合并后的数据
    store.commit("setInitrouter", constantRouterMap);
    //存储路由数据
    router.addRoutes(routerData);
  };
}
router.matcher = createRouter().matcher;
init();


// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.matched.some(res => res.meta.isLogin)) {//判断是否需要登录
    let backups = JSON.parse(localStorage.getItem('vuex-netUser'))
    // console.log(backups.netuser.state)
    if (backups.netuser.state > 0) {
      next();
    } else {
      store.commit("setLoginbox", true)
      message.error("未登录", 10);
      next(from);

    }
  } else {
    next()
  }
});
export default router


// WEBPACK FOOTER //
// ./src/router/index.js